import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { TrendingUp, Loader2 } from "lucide-react";

function AuthLoadingScreen() {
  return (
    <div
      data-testid="auth-loading-screen"
      className="min-h-screen bg-slate-950 flex flex-col items-center justify-center gap-4"
    >
      <div className="w-12 h-12 rounded-xl bg-emerald-500 flex items-center justify-center shadow-lg shadow-emerald-500/20">
        <TrendingUp className="w-6 h-6 text-slate-950" strokeWidth={2.5} />
      </div>
      <div className="flex items-center gap-2 text-slate-400 text-sm">
        <Loader2 className="w-4 h-4 animate-spin text-emerald-400" />
        <span>Loading your workspace...</span>
      </div>
    </div>
  );
}

export default function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) return <AuthLoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
